/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {ServiceDrivenDropDownFieldEditor} from "./ServiceDrivenDropDownFieldEditor";
import {service as SpeciesListService} from "../../../Services/SpeciesListService";
import {useSelector} from "react-redux";


export const SpeciesListPicker = ServiceDrivenDropDownFieldEditor(SpeciesListService);

export const SpeciesListFieldEditor = (props) => {
	
	
	const {RootData} = props;
	const parentSpeciesListId = RootData?.parentAssignedSpeciesListId ?? 'N/A';
	const parentSpeciesListName = SpeciesListService.CachedTitleById(parentSpeciesListId);
	
	const currentUser = useSelector(state => state.userState.user);
	const organizationId = RootData?.organizationId ?? currentUser?.organizationId;
	
	// SubProgram will have a value and Project will have undefined
	const speciesListIsOptional = (RootData?.parentProgramId !== null);

	const emptyValueOption = [{
		key: 0,
		value: '',
		title: 'Default' + (parentSpeciesListName ? ` (${parentSpeciesListName})` : ''),
	}];
	
	return <SpeciesListPicker
		context={{organizationId}}
		additionalOptions={speciesListIsOptional ? emptyValueOption : []}
		{...props}
	/>
	
}

